import { ThemeProvider } from "styled-components";
import { token } from "../../theme";
import {
  ItemsFolderContainer,
  ItemsFolderIcon,
  ItemsFolderName,
} from "./ItemsFolderStyles";
import React from "react";
import { useWindowManager } from "../../pages/HomePage/utils/WindowManager";
import {
  calculateCenterPosition,
  getRandomWindowPosition,
} from "../../pages/HomePage/utils/utils";
import defaultFolderIcon from "../../assets/images/directory.png";
import { iconMotionProps } from "../Effects/iconMotion";

interface ItemsFolderProps {
  folderName: string;
  component: React.ReactNode;
  folderIcon?: string;
  showAddressBar?: boolean;
  addressBarLink?: string;
  showBottomBar?: boolean;
  staggerIndex?: number;
}

//so this will be a folder where it will show up as a folder then when you double click it will appear as a window with the items inside it
const ItemsFolder = ({
  folderName = "New Folder",
  folderIcon = defaultFolderIcon,
  component,
  showAddressBar = false,
  addressBarLink = "",
  showBottomBar = false,
  staggerIndex = 0,
}: ItemsFolderProps) => {
  const { openWindow } = useWindowManager();
  const centerPos = calculateCenterPosition(400, 300);
  const handleOpenFolder = () => {
    openWindow({
      component: folderContentsComponent,
      isMinimized: false,
      isMaximized: false,
      icon: folderIcon,
      position: getRandomWindowPosition(centerPos),
      showAddressBar: false,
      addressBarLink: addressBarLink,
      showBottomBar: showBottomBar,
      windowTitle: folderName,
    });
  };

  const folderContentsComponent = () => {
    return (
      <div
        style={{
          background: token.white,
          boxShadow: token.invertedStandardBoxShadow,
        }}
      >
        {component}
      </div>
    );
  };
  return (
    <ThemeProvider theme={token}>
      <ItemsFolderContainer
        {...iconMotionProps(staggerIndex)}
        onDoubleClick={handleOpenFolder}
      >
        <ItemsFolderIcon src={folderIcon} />
        <ItemsFolderName>{folderName}</ItemsFolderName>
      </ItemsFolderContainer>
    </ThemeProvider>
  );
};

export default ItemsFolder;
